var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDurationdarkpurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.4991 3.37402C33.1567 3.37402 25.9791 5.55132 19.8741 9.63058C13.769 13.7098 9.01075 19.5078 6.20093 26.2913C3.39108 33.0749 2.65591 40.5393 4.08834 47.7407C5.5208 54.9418 9.05652 61.5568 14.2484 66.7488C19.4403 71.9407 26.0552 75.4763 33.2565 76.9089C40.4579 78.3411 47.9223 77.606 54.7057 74.7964C61.4893 71.9863 67.2872 67.2282 71.3665 61.1229C75.4458 55.0182 77.6231 47.8406 77.6231 40.4981C77.6115 30.6557 73.6967 21.2198 66.737 14.2602C59.7772 7.30062 50.3414 3.38564 40.4991 3.37402ZM53.0098 53.009C52.377 53.6418 51.519 53.9971 50.6239 53.9971C49.729 53.9971 48.8707 53.6418 48.2378 53.009L38.113 42.8842C37.4801 42.2514 37.1244 41.3931 37.1242 40.4981V20.2486C37.1242 19.3535 37.4798 18.4951 38.1127 17.8622C38.7456 17.2293 39.604 16.8737 40.4991 16.8737C41.3942 16.8737 42.2526 17.2293 42.8855 17.8622C43.5184 18.4951 43.874 19.3535 43.874 20.2486V39.1009L53.0098 48.2368C53.6426 48.8697 53.998 49.7279 53.998 50.6229C53.998 51.5176 53.6426 52.3762 53.0098 53.009Z",
    fill: "#321E5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDurationdarkpurple);
export default __webpack_public_path__ + "static/media/duration dark purple.cc26d0445d3ee69e1505c3a371133d19.svg";
export { ForwardRef as ReactComponent };